export default __webpack_public_path__ + "static/media/MensageriaSelected.74bc6ba7.svg";